import React from 'react';

const Skeleton = ({ width, height, borderRadius, className = "" }) => {
    return (
        <div
            className={`skeleton ${className}`}
            style={{
                width: width || '100%',
                height: height || '100%',
                borderRadius: borderRadius || 'var(--radius-md)'
            }}
        />
    );
};

export default Skeleton;
